import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, IconButton, Box, Menu, MenuItem, useMediaQuery, Hidden, Drawer, List, ListItem, ListItemText } from "@mui/material";
import { Phone, Email, Home, AccountCircle, Menu as MenuIcon } from "@mui/icons-material";

const CustomAppBar = ({ active }) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const storedEmail = sessionStorage.getItem('email');
        if (!storedEmail) return;

        const response = await fetch(`${REACT_APP_EXPRESS_SERVER}/profile/${storedEmail}`);
        if (!response.ok) return;
        
        const data = await response.json();
        setUserData(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchUserProfile();
  }, []);

  

  const username = sessionStorage.getItem('username');
  const vendorNo = sessionStorage.getItem('vendorNo');
  const isAdmin = userData && userData.CreatedBy === 'ADMIN' && userData.ModifiedBy === 'ADMIN';

  const navigateTo = (path) => {
    if (path === '/signup') {
      sessionStorage.removeItem('username');
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('vendorNo');
      navigate(path);
    }else{
    navigate(path);
    }
  };

  
  // Base drawer items that are always shown
  const baseDrawerItems = [
    { text: 'About', path: '/', activeKey: 'about' },
    { text: 'Application Guide', path: '/application', activeKey: 'application' },
    { text: 'Active RFPs', path: '/active-bids', activeKey: 'active' },
    { text: 'Archived RFPs', path: '/archived-bids', activeKey: 'archived' },
  ];
  
  // Items that require authentication
  const authDrawerItems = [
    { text: 'Private RFPs', path: '/private-bids', activeKey: 'private' },
    { text: 'Bids', path: '/my-bids', activeKey: 'bids' },
    { text: 'Prequalifications', path: '/my-prequalifications', activeKey: 'prequalifications' },
  ];
  const loginlogout = [
    { text: 'Login', path: '/signin', activeKey: 'Login' },
    { text: 'Register', path: '/signup', activeKey: 'Register' },

  ]
  const LoggedInUser = [
    { text: 'Profile', path: '/profile', activeKey: 'Profile' },
    { text: 'Contacts', path: '/contacts', activeKey: 'Contacts' },
    { text: 'Reset Password', path: '/forgot-password', activeKey: 'Reset password' },
    { text: 'Logout', path: '/signup', activeKey: 'Logout' },
  ]

  const Administrator =[

    { text: 'Receipt Management ', path: '/payment-management', activeKey: 'Receipt Management' },

  ]
  
  // Combine items based on authentication status
  const drawerItems = [
    ...baseDrawerItems,
    ...(username && vendorNo ? authDrawerItems : []),
  ];
  const drawerItemsSmallScreen = [
    ...baseDrawerItems,
    ...(username && vendorNo ? authDrawerItems : loginlogout),
    ...isAdmin ? Administrator :[],
    ...(username && vendorNo ? LoggedInUser : [])
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  

  // Check if user is admin
  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={handleDrawerToggle} onKeyDown={handleDrawerToggle}>
      <List>
        {drawerItemsSmallScreen.map((item) => (
          <ListItem button key={item.text} onClick={() => navigateTo(item.path)}>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      
    </Box>
  );

  return (
    <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Toolbar sx={{ justifyContent: "space-between", backgroundColor: "white", height: "65px" }}>
        <Box display="flex" alignItems="center">
          <img src="https://jms.co.ug/wp-content/uploads/2022/06/JMS_logo-1.png" alt="JMS Logo" onClick={() => {navigate('/'); }}style={{ height: 50, marginRight: 10 }} />
        </Box>
        <Hidden mdDown>
          <Box display="flex" alignItems="center" gap={3}>
            <Box display="flex" alignItems="center" gap={1}>
              <Phone color="error" />
              <div>
                <Typography variant="body1" sx={{ color: "grey", fontSize: 13 }}>Call Us Toll Free</Typography>
                <Typography variant="body1" sx={{ fontSize: 15 }}><b>0800203018 | 0800340340</b></Typography>
              </div>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Email color="error" />
              <div>
                <Typography variant="body1" sx={{ color: "grey", fontSize: 13 }}>Send Us Mail</Typography>
                <Typography variant="body1" sx={{ fontSize: 15 }}><b>tenders@jms.co.ug</b></Typography>
              </div>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Home color="error" />
              <div>
                <Typography variant="body1" sx={{ color: "grey", fontSize: 13 }}>Location</Typography>
                <Typography variant="body1" sx={{ fontSize: 15 }}><b>Plot 1828 Gongonya Road</b></Typography>
              </div>
            </Box>
          </Box>
        </Hidden>
        <Hidden mdUp>
          <IconButton color="inherit" aria-label="open drawer" edge="end" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>

      <Hidden mdDown>
        <Toolbar sx={{ backgroundColor: "white", borderTop: 1, borderColor: "divider" }}>
          {drawerItems.map((item) => (
            <Button
              key={item.text}
              sx={{
                color: active === item.activeKey ? "#5C2626" : "black",
                borderBottom: active === item.activeKey ? 3 : 0,
                borderColor: "#5C2626",
                borderRadius: 0,
                marginLeft: 2
              }}
              href={item.path}
            >
              <b>{item.text}</b>
            </Button>
          ))}
          <Box display="flex" gap={2} marginLeft="auto">
            {username ? (

              <ProfileRing userData={userData} />
            ) : (
              <>
                <Button variant="contained" color="error" href='/signin'>Login</Button>
                <Button variant="contained" color="error" href='/signup'>Register</Button>
              </>
            )}
          </Box>
        </Toolbar>
      </Hidden>

      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        {drawer}
      </Drawer>
    </AppBar>
  );
}





export default CustomAppBar;


const ProfileRing = ({userData}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();
  const username = sessionStorage.getItem('username');
  const isAdmin = userData && userData.CreatedBy === 'ADMIN' && userData.ModifiedBy === 'ADMIN';

  return (
   <Box display="flex" alignItems="center">
    <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} color="inherit">
      <AccountCircle />
    </IconButton>
    <Typography variant="body1">{username}</Typography>
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
      {isAdmin && (
        <MenuItem onClick={() => {navigate('/payment-management'); }}>Receipt Management</MenuItem>
      )}
      <MenuItem onClick={() => {navigate('/profile'); }}>Profile</MenuItem>
      <MenuItem onClick={() => {navigate('/contacts'); }}>Contacts</MenuItem>
      <MenuItem onClick={() => {navigate('/forgot-password'); }}>Forgot Password</MenuItem>
      <MenuItem onClick={() => { 
        sessionStorage.removeItem('username');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('vendorNo');
        navigate('/signin'); }}>Logout</MenuItem>
    </Menu>
  </Box>
  )
}